// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"XButton__closeButton--3Ma","firstPart":"XButton__firstPart--2vy","secondPart":"XButton__secondPart--3kD","leaderBoardColor":"XButton__leaderBoardColor--1_P"};